const config = {
  configEndpoints: {
    baseEndpoint: "http://localhost:9000",
  },
  configGoogleTagManager: {
    gtmId: "GTM-NL6LH2C",
  },
  configLiveChat: {
    script: "//js.hs-scripts.com/8487018.js?businessUnitId=108691",
  },
  configIntercom: {
    enabled: false,
  },
  configLogicMonitor: {
    baseUrl: "https://dc.api.masro.io/uat",
    jsBundleUrl: "https://s3.eu-west-2.amazonaws.com/dc.masro.io/js/logicone.js",
  },
};

export default config;
